import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import List from './List'
import CodeDetail from './CodeDetail'

const Development = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <List />
      </Route>
      <Route exact path={`${path}/codeDetail/:id`}>
        <CodeDetail />
      </Route>
    </Switch>
  )
}

export default Development
